import Pusher from 'pusher-js/with-encryption';
import { eventChannel } from 'redux-saga';
import { getToken } from './common/utils/get-token.js';
import { apiEndpoint, context, pusherCluster, pusherKey } from './config.js';

Pusher.logToConsole = context.tier === 'dev';

let pusher: Pusher;
let token: string | null;

export function getPusher() {
  const currentToken = getToken();

  if (!pusher || currentToken !== token) {
    token = currentToken;
    pusher = new Pusher(pusherKey, {
      authEndpoint: `${apiEndpoint}/project/channel-auth`,
      authTransport: 'ajax',
      auth: {
        headers: {
          'X-TakeShape-Token': token
        }
      },
      cluster: pusherCluster
    });
  }

  return pusher;
}

export function getProjectChannelName(projectId: string) {
  return `presence-project.${projectId}`;
}

export function pusherChannel(channelName: string, events: string[]) {
  const pusher = getPusher();
  return eventChannel((emitter) => {
    const channel = pusher.subscribe(channelName);
    for (const event of events) {
      channel.bind(event, (payload: unknown) => {
        emitter({ type: event, payload });
      });
    }

    return () => {
      pusher.unsubscribe(channelName);
    };
  });
}
